import { render } from "./CertificateList.vue?vue&type=template&id=5941cdd6&scoped=true&ts=true"
import script from "./CertificateList.vue?vue&type=script&lang=ts"
export * from "./CertificateList.vue?vue&type=script&lang=ts"

import "./CertificateList.vue?vue&type=style&index=0&id=5941cdd6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5941cdd6"]])

export default __exports__